import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, COMPANY_REVIEW_LIST, PUBLIC } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${COMPANY_REVIEW_LIST}`

export const fetchPublicCompanyReviews = async (uuid) => {
  const url = `${API_BASE_URL}/${uuid}?perPageCount=5`; // Proxy path
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    const errorMessage = error.message;

  }
};